import type { LinkingMatrix } from '../types';

export const MATRIX: LinkingMatrix = {
    results: [],
    watchlist: [],
    'order-blotter': ['order-blotter', 'messages', 'positions', 'executions', 'orders'],
    'trade-pro': [],
    'trade-pro-multi': [],
    'basket-trading': [],
    'manual-review': [],
    messages: ['order-blotter', 'messages', 'positions', 'executions', 'orders'],
    positions: [],
    executions: ['messages', 'executions'],
    accounts: [],
    orders: [],
    locates: ['locates', 'lab'],
    lab: ['locates', 'lab'],
    table: [],
    'alpha-lens': [],
    searchalpha: [],
    scanner: [],
    screener: [],
    news: [],
    events: [],
    filings: [],
    notepad: [],
    'alpha-eye': [],
    platforms: [],
    symbols: [],
    traders: [],
    alerts: [],
    backtest: [],
    'tradingview-chart': [],
};
